var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('b',[_vm._v("\n      "+_vm._s(_vm.atributNaziv)+":\n    ")])]),_vm._v("\n  "+_vm._s(_vm.narocilo[_vm.atribut])+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cd788f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Mojprofil/T2klub/MojaNarocilaInfo/MojaNarocilaParagraf.vue
// module id = mp2W
// module chunks = 3